import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { Header } from '../components/Header';
import { ProfileForm } from '../components/profile/ProfileForm';
import { AddressList } from '../components/profile/AddressList';
import { useAuthStore } from '../stores/useAuthStore';

export function ProfilePage() {
    const navigate = useNavigate();
    const logout = useAuthStore((state) => state.logout);

    const handleLogout = () => {
        const state = useAuthStore.getState();
        const entryToken = sessionStorage.getItem('entry_token');
        const tenantUuid = state.tenantUuid;
        const identifier = state.identifier;

        // Calcular destino antes de limpiar el store
        const target = entryToken || tenantUuid || (!identifier?.includes('@') ? identifier : null);
        const destination = target ? `/${target}` : '/login';

        logout();

        // Usamos window.location.href para forzar una recarga completa y evitar
        // que el componente ProtectedRoute intercepte el cambio de estado con un Navigate
        window.location.href = destination;
    };

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 pb-32">
            <Header title="Mi Perfil" showBack />

            <div className="max-w-xl mx-auto p-6 space-y-8">

                {/* Profile Info Section */}
                <section>
                    <ProfileForm />
                </section>

                {/* Addresses Section */}
                <section className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-sm border border-gray-100 dark:border-gray-700">
                    <AddressList />
                </section>

                {/* Logout Button */}
                <button
                    onClick={handleLogout}
                    className="w-full flex items-center justify-center gap-2 p-4 text-red-500 font-semibold hover:bg-red-50 dark:hover:bg-red-900/10 rounded-xl transition-colors"
                >
                    <LogOut className="w-5 h-5" />
                    Cerrar Sesión
                </button>
            </div>
        </div>
    );
}
